import React from 'react';
import TextareaAutosize from '@mui/material/TextareaAutosize';
import { styled } from '@mui/system';

const StyledTextarea = styled(TextareaAutosize)(({ theme }) => ({
  width: '98%',
  backgroundColor: '#FFFFFF',
  borderRadius: '10px',
  fontWeight: 400,
  fontSize: '18px',
  lineHeight: '24px',
  padding: '10px 5px',
  border: '1px solid rgba(0, 0, 0, 0.3)',
  resize: 'none',
  fontFamily:'Roboto',
  '&:focus': {
    outline: 'none',
    borderColor: '#1976d2',
  },
}));

export default function TextArea({ id, name, placeholder, value, onChange, disabled, minRows = 2 }) {
  return (
    <StyledTextarea
      id={id}
      name={name}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      disabled={disabled}
      minRows={minRows}
    />
  );
}
